import request from '@/utils/request'

// 分页查询安全环保计划列表
export function querySafetyPlanList(data) {
  return request({
    url: '/crmSafetyPlan/queryList',
    method: 'post',
    data: data
  })
}

// 查询安全环保计划详情
export function querySafetyPlanDetail(query) {
  return request({
    url: '/crmSafetyPlan/queryDetail',
    method: 'get',
    params: query
  })
}

// 新增安全环保计划
export function addSafetyPlan(data) {
  return request({
    url: '/crmSafetyPlan/add',
    method: 'post',
    data: data
  })
}

// 更新安全环保计划
export function updateSafetyPlan(data) {
  return request({
    url: '/crmSafetyPlan/update',
    method: 'put',
    data: data
  })
}

// 删除安全环保计划
export function deleteSafetyPlan(data) {
  return request({
    url: '/crmSafetyPlan/delete',
    method: 'delete',
    data: data
  })
}